/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Pending_Old_DraftInputs */

const vi_einvoice_pending_old_draft = /** @type {(inputs: Einvoice_Pending_Old_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Còn một nháp cũ trên MISA, chưa ai ký.`)
};

/**

* @param {Einvoice_Pending_Old_DraftInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_pending_old_draft = /** @type {((inputs?: Einvoice_Pending_Old_DraftInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Pending_Old_DraftInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_pending_old_draft(inputs)
});